import { render, staticRenderFns } from "./ShippingServiceChargesComponent.vue?vue&type=template&id=691b27eb&"
import script from "./ShippingServiceChargesComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingServiceChargesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports